import React from 'react';

interface QuarterlyMonthlyToggleProps {
  value: 'quarterly' | 'monthly';
  onChange: (value: 'quarterly' | 'monthly') => void;
}

export const QuarterlyMonthlyToggle: React.FC<QuarterlyMonthlyToggleProps> = ({ value, onChange }) => {
  const btn = (active: boolean) =>
    `px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
      active ? 'bg-blue-600 text-white' : 'text-gray-400 hover:text-white hover:bg-gray-800'
    }`;

  return (
    <div className="inline-flex gap-1 bg-surface border border-border rounded-lg p-1">
      <button className={btn(value === 'quarterly')} onClick={() => onChange('quarterly')}>
        Quarterly
      </button>
      <button className={btn(value === 'monthly')} onClick={() => onChange('monthly')}>
        Monthly
      </button>
    </div>
  );
};
